// extracted by mini-css-extract-plugin
export default {"iconInfo":"I4DiaHAE77iNMl0m3Stf"};